import React, { Fragment, useEffect, useRef } from "react";
import JsQrReader from "./JsQrReader";
import { signal } from "@preact/signals-react";

import proxy from "api/proxy";
import PureModal from "components/Modals/PureModal";
import { QrCodeIcon, XMarkIcon } from "components/Icons";
import StdButton from "components/Buttons/StdButton";
import { useIdSeq } from "store/idSeq";
import mainStore from "store/mainStore";
import { Alert } from "components/Alerts/Alert";
import { getStorage, setStorage } from "store/local";

const showModal = signal(false);

export const productState = signal({
  product: null,
  alert: {
    show: false,
    text: "Producto agregado",
    icon: "check",
    color: "bg-green-200",
  },
  exists: false,
});

const AddProduct = (data) => {
  console.log(data, "este es el data");

  const ctxView = data?.attrs?.ctxView.model || data;

  const { seq, increment } = useIdSeq();
  const { store: storeRecord, updateRecord, updateStore, record } = mainStore();

  const ctxSession = getStorage("ctxSession");
  const from_location = storeRecord?.from_location?.id;

  const isFetching = useRef(false);
  const lastCode = useRef(null);

  useEffect(() => {
    const updateSessionLocation = async () => {
      const _session = { ...getStorage("ctxSession") };

      if (from_location) {
        _session.locations = [from_location];
      } else {
        _session.locations = [ctxSession?.warehouse?.id];
      }

      await setStorage("ctxSession", _session);
    };

    updateSessionLocation();
  }, []);

  const getData = async (code) => {
    if (!code || isFetching.current || lastCode.current === code) return;

    lastCode.current = code;
    isFetching.current = true;

    try {
      const { data: res } = await proxy.search(
        "product.product",
        [["reference", "=", code]],
        [
          "id",
          "list_price",
          "rec_name",
          "name",
          "code",
          "quantity",
          "sale_price_w_tax",
          "sale_uom.rec_name",
          "reference",
        ],
      );

      if (res.length > 0) {
        productState.value = {
          ...productState.value,
          product: res[0],
          exists: false,
        };
      }
    } finally {
      isFetching.current = false;
    }
  };

  const handleQr = (result, error) => {
    if (result?.text) getData(result.text);
    if (error) console.info(error);
  };

  const RowSection = ({ name = "", value = "" }) => (
    <div className="flex justify-between space-x-2 py-2">
      <span className="font-medium">{name}</span>
      <span>{value}</span>
    </div>
  );

  // 🔥 CENTRALIZADO
  const executeAddLine = async () => {
    let response = false;
    console.log(ctxView, "este es el modelo");

    switch (ctxView) {
      case "stock.shipment.internal":
        console.log("paso por,", ctxView);

        response = await addLineShipmenpInternal();
        break;

      case "stock.shipment.out.return":
        response = await addLineRequisition();
        break;

      case undefined:
      case "comment":
        response = await addLine();
        break;

      default:
        response =
          data?.field?.name === "reference"
            ? await addLineRequisition()
            : await addLine();
    }

    return response;
  };

  // =========================
  // ADD LINE NORMAL
  // =========================
  const addLine = () => {
    if (!productState.value.product) return false;

    const _storeRecord = { ...storeRecord };
    let _activeRecord = { ...record };

    const productReference = productState.value.product.reference;

    const exists = Array.from(_activeRecord.lines?.values?.() || []).some(
      (line) => line.reference === productReference,
    );

    if (exists) {
      productState.value = {
        ...productState.value,
        exists: true,
        alert: {
          show: true,
          text: "Este producto ya está en la lista",
          icon: "xmark",
          color: "bg-red-200",
        },
      };
      return false;
    }

    const seqId = seq;

    const line_ = {
      id: seqId,
      code: productState.value.product.code,
      reference: productState.value.product.reference,
      unit_price: productState.value.product.list_price || 1,
      sale_price_taxed: productState.value.product.sale_price_w_tax || 1,
      product: productState.value.product,
      quantity: 1,
      unit: productState.value.product?.["sale_uom."],
      listing: true,
    };

    const lineStore_ = {
      id: seqId,
      product: productState.value.product.id,
      unit_price: productState.value.product.list_price || 1,
      base_price: productState.value.product.sale_price_w_tax || 1,
      quantity: 1,
      unit: productState.value.product?.["sale_uom."]?.id,
    };

    if (!_storeRecord.lines) {
      _storeRecord.lines = new Map();
      _storeRecord.lines.set("create", new Map());
    }

    _storeRecord.lines.get("create").set(seqId, lineStore_);
    _activeRecord.lines.set(seqId, line_);

    increment(seqId - 1);
    updateRecord(_activeRecord);
    updateStore(_storeRecord);

    productState.value = {
      ...productState.value,
      alert: {
        show: true,
        text: "Producto agregado",
        icon: "check",
        color: "bg-green-200",
      },
      product: null,
    };

    return true;
  };

  // =========================
  // REQUISITION
  // =========================
  const addLineRequisition = () => {
    if (!productState.value.product) return false;

    const _storeRecord = { ...storeRecord };
    let _activeRecord = { ...record };
    const seqId = seq;

    const line_ = {
      id: seqId,
      unit_price: productState.value.product.list_price || 0,
      product: productState.value.product,
      quantity: 1,
      unit: productState.value.product?.["sale_uom."],
    };

    const lineStore_ = {
      id: seqId,
      product: productState.value.product.id,
      unit_price: productState.value.product.list_price || 0,
      quantity: 1,
      unit: productState.value.product?.["sale_uom."]?.id,
      from_location: record?.customer?.customer_location,
      to_location: record?.warehouse_input,
      currency: ctxSession?.currency,
    };

    if (!_storeRecord.moves) {
      _storeRecord.moves = new Map();
      _storeRecord.moves.set("create", new Map());
    }

    _storeRecord.moves.get("create").set(seqId, lineStore_);
    _activeRecord.moves.set(seqId, line_);

    increment(seqId - 1);
    updateRecord(_activeRecord);
    updateStore(_storeRecord);

    productState.value = {
      ...productState.value,
      alert: {
        show: true,
        text: "Producto agregado",
        icon: "check",
        color: "bg-green-200",
      },
      product: null,
    };

    return true;
  };

  // =========================
  // INTERNAL SHIPMENT
  // =========================
  const addLineShipmenpInternal = () => {
    if (!productState.value.product) return false;
    console.log(productState.value, "este es el producto");

    const _storeRecord = { ...storeRecord };
    let _activeRecord = { ...record };
    const productReference = productState.value.product.reference;

    console.log(
      productState.value.product?.["sale_uom."],
      "productState.value.product?.sale_uom",
    );

    const exists = Array.from(_activeRecord.moves?.values?.() || []).some(
      (line) => line.product.reference === productReference,
    );

    if (exists) {
      productState.value = {
        ...productState.value,
        exists: true,
        alert: {
          show: true,
          text: "Este producto ya está en la lista",
          icon: "xmark",
          color: "bg-red-200",
        },
      };
      return false;
    }

    const seqId = seq;

    const line_ = {
      id: seqId,
      unit_price: productState.value.product.list_price || 0,
      product: productState.value.product,
      quantity: 1,
      unit: productState.value.product?.["sale_uom."],
    };

    const lineStore_ = {
      id: seqId,
      product: productState.value.product.id,
      unit_price: productState.value.product.list_price || 0,
      quantity: 1,
      from_location: _activeRecord?.from_location?.id,
      to_location: _activeRecord?.to_location?.id,
      unit: productState.value.product?.["sale_uom."]?.id,
    };

    if (!_storeRecord.moves) {
      _storeRecord.moves = new Map();
      _storeRecord.moves.set("create", new Map());
    }

    _storeRecord.moves.get("create").set(seqId, lineStore_);
    _activeRecord.moves.set(seqId, line_);

    increment(seqId - 1);
    updateRecord(_activeRecord);
    updateStore(_storeRecord);

    productState.value = {
      ...productState.value,
      alert: {
        show: true,
        text: "Producto agregado",
        icon: "check",
        color: "bg-green-200",
      },
      product: null,
    };

    return true;
  };

  const ContentModal = ({ onClose }) => {
    const product = productState.value.product;
    const quantity = product?.quantity || 0;
    const exist = true;

    return (
      <Fragment>
        <Alert {...productState.value.alert} position="absolute z-10" />

        <div className="md:grid md:grid-cols-2 rounded-md w-full relative">
          <button
            className="absolute top-2 right-5 bg-red-300 p-1 rounded-full"
            onClick={onClose}
          >
            <XMarkIcon className="h-10 w-10 text-rose-900" />
          </button>

          <JsQrReader onResult={handleQr} />

          <div className="p-4 flex flex-col justify-between">
            <div>
              <div className="flex justify-between mb-6">
                <span className="text-xl">Detalle del producto</span>
                {product?.code && (
                  <span className="bg-sky-950 text-white px-4 rounded-full">
                    # {product.code}
                  </span>
                )}
              </div>

              {product && (
                <div className="divide-y border-y">
                  <RowSection name="Nombre" value={product.name} />
                  <RowSection name="Precio" value={product.sale_price_w_tax} />
                  <RowSection name="Referencia" value={product.reference} />
                  <RowSection name="Cantidad" value={product.quantity} />
                </div>
              )}
            </div>

            <div className="pt-3 flex space-x-2">
              {exist && quantity > 0 && (
                <>
                  <StdButton
                    size="w-full"
                    content="AGREGAR"
                    onClick={executeAddLine}
                    disabled={!exist}
                  />

                  <StdButton
                    size="w-full"
                    content="AGREGAR/CERRAR"
                    onClick={async () => {
                      const ok = await executeAddLine();
                      if (ok) showModal.value = false;
                    }}
                    disabled={!exist}
                  />
                </>
              )}

              {product && quantity === 0 && (
                <div className="text-red-950 text-center w-full">
                  Este producto no existe en esta bodega
                </div>
              )}
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  useEffect(() => {
    if (showModal.value) {
      productState.value = {
        product: null,
        alert: { show: false, text: "", icon: "check", color: "bg-green-200" },
        exists: false,
      };
      lastCode.current = null;
    }
  }, [showModal.value]);

  return (
    <Fragment>
      <div
        className="bg-yellow-500 px-6 py-4 flex items-center justify-center space-x-3 rounded-md cursor-pointer mx-auto my-10"
        onClick={() => (showModal.value = true)}
      >
        <QrCodeIcon className="w-8 text-black" />
        <span className="text-black">Scanea y agrega los cilindros</span>
      </div>

      <PureModal
        open={showModal.value}
        onClose={() => (showModal.value = false)}
        overflow="overflow-hidden"
      >
        <ContentModal onClose={() => (showModal.value = false)} />
      </PureModal>
    </Fragment>
  );
};

export default AddProduct;
